import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=10256811&scoped=true&"
import script from "./FileViewer.vue?vue&type=script&lang=ts&"
export * from "./FileViewer.vue?vue&type=script&lang=ts&"
import style0 from "./FileViewer.vue?vue&type=style&index=0&id=10256811&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10256811",
  null
  
)

export default component.exports